module.exports = __webpack_public_path__ + "static/media/smarty-bubbles.4fc61b87.jpg";